module.exports = __webpack_public_path__ + "media/kri.a9376780.mp3";